// extracted by mini-css-extract-plugin
export default {"lostItemFeePolicyForm":"lostItemFeePolicyForm---Iv1Hn"};